import styled from 'styled-components';

import { Variables } from '../../../styles/Variables';

export const Button = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 70px;
  background-color: ${Variables.colorBlue};
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: ${Variables.colorWhite};
  display: flex;
  justify-content: center;
  align-items: center;

  & :hover {
    opacity: 0.8;
  }
`;
